/**
 * Centralized, declarative Query Key factory.
 * Keeping query keys in one place prevents typo bugs in refetching and invalidation.
 */
export const queryKeys = {
  auth: {
    session: () => ['auth', 'session'] as const,
    user: () => ['auth', 'user'] as const,
    profile: (userId: string) => ['auth', 'profile', userId] as const,
    adminProfile: (userId: string) => ['auth', 'adminProfile', userId] as const,
  },
  user: {
    profile: (userId: string) => ['user', 'profile', userId] as const,
    gamification: (userId: string) => ['user', 'gamification', userId] as const,
    league: (userId: string) => ['user', 'league', userId] as const,
  },
  ecopontos: {
    list: () => ['ecopontos', 'list'] as const,
    detail: (id: string) => ['ecopontos', 'detail', id] as const,
    materials: (id: string) => ['ecopontos', 'materials', id] as const,
    partners: (id: string) => ['ecopontos', 'partners', id] as const,
  },
  descartes: {
    all: () => ['descartes'] as const,
    history: (userId: string) => ['descartes', 'history', userId] as const,
    feedback: (discardId: string) => ['descartes', 'feedback', discardId] as const,
    stats: (location?: string) => ['descartes', 'stats', location || 'global'] as const,
  },
};
